import { useState } from "react";
import { http, formatErr } from "../lib/api";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

const inp = "w-full px-3 py-2 rounded-md border text-sm";
const bs = { borderColor: "var(--border-silver)" };

// Cambio password (agente): password attuale obbligatoria; le altre sessioni vengono chiuse dal server.
export function PasswordChange() {
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 12) return toast.error("Nuova password troppo corta (minimo 12 caratteri).");
    setBusy(true);
    try { await http.post("/auth/change-password", f); setF({ current_password: "", new_password: "" }); toast.success("Password aggiornata. Le altre sessioni sono state chiuse."); }
    catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };
  return (
    <section className="card-clean p-5 mt-5" data-testid="password-change">
      <h2 className="font-serif text-xl mb-3 flex items-center gap-2"><KeyRound className="w-5 h-5" /> Cambio password</h2>
      <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <input type="password" required placeholder="Password attuale" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} autoComplete="current-password" data-testid="pc-current" className={inp} style={bs} />
        <input type="password" required placeholder="Nuova password (min 12)" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} autoComplete="new-password" data-testid="pc-new" className={inp} style={bs} />
        <button type="submit" disabled={busy} data-testid="pc-submit" className="sm:col-span-2 px-3 py-2 rounded-md text-white text-sm disabled:opacity-50" style={{ background: "var(--brand-dark)" }}>Aggiorna password</button>
      </form>
    </section>
  );
}
